var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tooltip",on:{"click":_vm.onClick,"mouseover":_vm.onMouseover,"mouseout":_vm.onMouseout}},[_c('span',{class:_vm._tooltipTextWrapperClass,style:(_vm.tooltipTextWrapperStyle)},[_c('span',{class:_vm.tooltipTextClass,style:(_vm.tooltipTextStyle)},[_vm._v("\n      "+_vm._s(_vm.tooltipText)+"\n    ")])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }